import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  Avatar,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogContentText,
  DialogActions,
  Switch,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbarCustom from "examples/Navbars/DashboardNavbarCustom";
import SoftBox from "components/SoftBox";
import { commonTextLabelStyle } from "styles/muiStyles";
import { updateUser, getUserInfo, checkPhoneNumber } from "api/UserAPI";
import { check2FA, disable2FA } from "api/api_register2FA";
import Register2FAScanQR from "layouts/authentication/2FA/Register2FAScanQR";
import Swal from "sweetalert2";
import SuiTypography from "components/SuiTypography";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
TabPanel.defaultProps = {
  children: null,
};

function DetailUser({ workingPage, childPage }) {
  const [userData, setUserData] = useState({
    fullname: "",
    email: "",
    phoneNumber: "",
    roleId: "",
    departmentId: "",
    administrativeAreaId: "",
    partnerId: "",
    username: "",
    fullNameLeader1: "",
    fullNameLeader2: "",
    deptName: "",
    roleName: "",
    twofaType: "",
  });

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [isDisabling2FA, setIsDisabling2FA] = useState(false);
  const [open2FADialog, setOpen2FADialog] = useState(false);
  const [twoFAType, setTwoFAType] = useState(0);
  const [checkExisted, setCheckExisted] = useState({
    message: "",
    status: Number,
  });

  const checkExistedPhoneNumber = async (value) => {
    const res = await checkPhoneNumber(value);
    if (res.status === 400 && !res.object) {
      setCheckExisted({
        message: res.message,
        status: 400,
      });
    } else if (res.status === 200 && res.object) {
      setCheckExisted({
        message: "",
        status: 200,
      });
    }
  };
  const isValidPhoneNumber = (phoneNumber) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phoneNumber);
  };

  const isDigitString = (str) => /^\d+$/.test(str);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phoneNumber" && value !== "" && !isDigitString(value)) return;
    setUserData((prevData) => ({ ...prevData, [name]: value }));
    if (name === "phoneNumber") {
      if (value.length === 10 && isValidPhoneNumber(value)) {
        checkExistedPhoneNumber(value);
      } else {
        if (checkExisted.message !== "") {
          setCheckExisted({
            message: "",
            status: 200,
          });
        }
      }
    }
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleDisable2FA = async () => {
    try {
      setIsDisabling2FA(true);
      const response = await disable2FA(userData.username);

      if (response && response.status === 200) {
        setTwoFAType(0);
        Swal.fire({
          title: "Tắt xác thực 2 bước thành công",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        Swal.fire({
          title: "Tắt xác thực 2 bước thất bại",
          text: response?.message || "Đã xảy ra lỗi",
          icon: "error",
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Error disabling 2FA:", error);
      Swal.fire({
        title: "Lỗi",
        text: "Đã xảy ra lỗi khi tắt xác thực 2 bước",
        icon: "error",
        showConfirmButton: true,
      });
    } finally {
      setIsDisabling2FA(false);
      handleCloseConfirmDialog();
    }
  };
  const handleOpen2FADialog = () => {
    setOpen2FADialog(true);
  };
  const handle2FAToggle = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      // Bật 2FA
      handleOpen2FADialog();
    } else {
      // Tắt 2FA
      setOpenConfirmDialog(true);
    }
  };

  const handleUpdateUser = () => {
    if (
      userData.fullname === "" ||
      userData.roleId === "" ||
      userData.departmentId === "" ||
      userData.partnerId === "" ||
      userData.administrativeAreaId === "" ||
      checkExisted.message !== ""
    ) {
      console.log("lỗi");
    } else {
      const userToken = JSON.parse(localStorage.getItem("user"));
      updateUser(userData).then((data) => {
        if (data) {
          if (data.status === 200) {
            Swal.fire({
              title: "Cập nhật thành công",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
            });
            userToken.fullName = data.object.fullName;
            localStorage.setItem("user", JSON.stringify(userToken));
          }
        } else {
          Swal.fire({
            title: "Cập nhật thất bại",
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    }
  };

  // Mở dialog thiết lập 2FA

  // Đóng dialog thiết lập 2FA
  const handleClose2FADialog = () => {
    setOpen2FADialog(false);
    // Nếu đang bật 2FA nhưng người dùng đóng dialog mà chưa hoàn tất việc bật
  };

  // Lấy tình trạng 2FA hiện tại của người dùng
  const fetchUserTwoFAStatus = async (username) => {
    try {
      const response = await check2FA(username);

      if (response && response.status === 200) {
        setTwoFAType(response.object.twofaType || 0);
      }
    } catch (error) {
      console.error("Error fetching 2FA status:", error);
    }
  };

  useEffect(() => {
    const userToken = JSON.parse(localStorage.getItem("user"));
    getUserInfo(userToken.userId)
      .then((result) => {
        console.log(result.object);
        setUserData(result.object);

        // Lấy trạng thái 2FA
        if (result.object && result.object.username) {
          fetchUserTwoFAStatus(result.object.username);
        }
      })
      .catch((error) => console.error("Error fetching users", error));
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbarCustom page={workingPage} childPage={childPage} />
      <SoftBox sx={{ mt: 3, px: 3, backgroundColor: "white !important" }}>
        <Box textAlign="center" my={4}>
          <Typography variant="h6" gutterBottom>
            Thông tin cá nhân
          </Typography>
          <Avatar sx={{ width: 80, height: 80, margin: "0 auto" }} />
        </Box>
        <Grid container spacing={2}>
          <Grid container spacing={3} mb={2} mt={2}>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label={
                  <span>
                    Tên đăng nhập
                    <span style={{ color: "#FF0000" }}>*</span>
                  </span>
                }
                disabled
                className="form-field"
                fullWidth
                name="position"
                value={userData.username}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                id="outlined-required"
                label={
                  <span>
                    Họ tên
                    <span style={{ color: "#FF0000" }}>*</span>
                  </span>
                }
                className="form-field"
                sx={commonTextLabelStyle}
                fullWidth
                name="fullname"
                value={userData.fullname}
                onChange={handleChange}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={2}>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Email"
                className="form-field"
                fullWidth
                name="email"
                value={userData.email}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Số điện thoại"
                className="form-field"
                fullWidth
                name="phoneNumber"
                inputProps={{ maxLength: 10 }}
                value={userData.phoneNumber}
                onChange={handleChange}
                error={checkExisted.message === "Số điện thoại này đã được sử dụng."}
                helperText={
                  checkExisted.message === "Số điện thoại này đã được sử dụng."
                    ? checkExisted.message
                    : ""
                }
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={2}>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Tên lãnh đạo trực tiếp 1"
                className="form-field"
                fullWidth
                name="fullNameLeader1"
                value={userData.fullNameLeader1}
                onChange={handleChange}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Tên lãnh đạo trực tiếp 2"
                className="form-field"
                fullWidth
                name="fullNameLeader2"
                value={userData.fullNameLeader2}
                onChange={handleChange}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={2}>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Vai trò"
                className="form-field"
                fullWidth
                name="roleName"
                value={userData.roleName}
                onChange={handleChange}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Phòng ban"
                className="form-field"
                fullWidth
                name="deptName"
                value={userData.deptName}
                onChange={handleChange}
                disabled
              />
            </Grid>
          </Grid>

          <Grid container spacing={3} mb={2}>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "0px 5px",
                  borderRadius: "8px",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", flex: "1" }}>
                  <FormControlLabel
                    control={<Switch checked={twoFAType > 0} onChange={handle2FAToggle} />}
                    label={
                      <span style={{ fontSize: "16px", fontWeight: "500" }}>Xác thực 2 bước</span>
                    }
                    labelPlacement="start"
                    sx={{
                      margin: 0,
                      "& .MuiFormControlLabel-label": {
                        marginRight: "16px",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Box textAlign="center" mt={3}>
          <Button
            sx={{
              "&.MuiButton-root.MuiButton-contained": {
                boxShadow: "none !important",
                fontWeight: "normal",
                height: "36px !important",
                maxHeight: "36px !important",
              },
              "&.MuiButton-root": {
                minHeight: "36px !important",
              },
            }}
            style={{
              fontWeight: "normal",
              width: "18%",
            }}
            variant="contained"
            onClick={handleUpdateUser}
          >
            Lưu
          </Button>
        </Box>

        {/* Dialog xác nhận tắt 2FA */}
        <Dialog
          open={openConfirmDialog}
          onClose={handleCloseConfirmDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: {
              borderRadius: "8px",
            },
          }}
        >
          <DialogTitle
            whiteSpace="nowrap"
            variant="body2"
            fontSize="18px"
            fontWeight="bold"
            color="#fff"
            sx={{
              textTransform: "none",
              textAlign: "left",
              color: "white",
              backgroundColor: "var(--blue-blue-100)",
              padding: "10px 24px",
            }}
            id="customized-dialog-title"
          >
            Xác nhận tắt xác thực 2 bước
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <SuiTypography
                textAlign="center"
                whiteSpace="normal"
                fontSize="18px"
                style={{
                  marginTop: "10px",
                  textTransform: "none",
                  wordBreak: "break-word",
                }}
              >
                Bạn có chắc chắn muốn tắt xác thực 2 bước không?
              </SuiTypography>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ pb: 2, px: 3 }}>
            <Button
              onClick={() => {
                handleCloseConfirmDialog();
              }}
              variant="outlined"
              disabled={isDisabling2FA}
            >
              Hủy
            </Button>
            <Button
              onClick={handleDisable2FA}
              variant="contained"
              autoFocus
              disabled={isDisabling2FA}
            >
              {isDisabling2FA ? "Đang xử lý..." : "Xác nhận"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog thiết lập 2FA */}
        <Dialog
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          open={open2FADialog}
          onClose={handleClose2FADialog}
        >
          <DialogTitle
            whiteSpace="nowrap"
            variant="body2"
            fontSize="18px"
            fontWeight="bold"
            color="#fff"
            sx={{
              textTransform: "none",
              textAlign: "left",
              color: "white",
              backgroundColor: "var(--blue-blue-100)",
              padding: "10px 24px",
            }}
            id="customized-dialog-title"
          >
            {twoFAType > 0 ? "Thay đổi" : "Thiết lập"} xác thực hai bước
            <IconButton
              aria-label="close"
              onClick={handleClose2FADialog}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ width: "100%", marginBottom: 2 }}>
              <Register2FAScanQR
                authenType={{ authenTypeName: "GGA" }}
                onSuccess={() => {
                  setTwoFAType(3);
                  setOpen2FADialog(false);
                  Swal.fire({
                    title: "Thiết lập xác thực 2 bước thành công",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 2000,
                  });
                }}
              />
            </Box>
          </DialogContent>
        </Dialog>
      </SoftBox>
    </DashboardLayout>
  );
}

DetailUser.defaultProps = {
  workingPage: "",
  childPage: [],
};

DetailUser.propTypes = {
  workingPage: PropTypes.string,
  childPage: PropTypes.arrayOf(PropTypes.string),
};

export default DetailUser;
